const SCRIPTS_ROUTE_PATTERN = /^\/scripts\/([^/]+)(?:\/videos)?\/?$/;

export const parseScriptsRoute = (pathname) => {
  const match = pathname.match(SCRIPTS_ROUTE_PATTERN);
  return {
    scriptHash: match?.[1] ? decodeURIComponent(match[1]) : null,
    showVideos: Boolean(match && pathname.includes("/videos")),
  };
};

export const scriptDetailPath = (scriptHash) =>
  `/scripts/${encodeURIComponent(scriptHash)}/`;

export const scriptVideosPath = (scriptHash, { create = false } = {}) => {
  const base = `/scripts/${encodeURIComponent(scriptHash)}/videos/`;
  return create ? `${base}?create=1` : base;
};
